export type RoleBadgeSource = {
  name: string;
};

export type VisibleRoleBadges<T extends RoleBadgeSource> = {
  shown: T[];
  restNames: string[];
};

/** At most `limit` badges; the rest become a single “+N” with their names. */
export function visibleRoleBadges<T extends RoleBadgeSource>(
  roles: readonly T[],
  limit = 2,
): VisibleRoleBadges<T> {
  return {
    shown: roles.slice(0, limit),
    restNames: roles.slice(limit).map((role) => role.name),
  };
}
